import React from 'react';
import { Helmet } from 'react-helmet';

const AdSenseScript = () => {
  return (
    <Helmet>
      <script
        async
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2004114604148310"
        crossOrigin="anonymous"
      />
    </Helmet>
  );
};

export default AdSenseScript;